import { routeTreeToDefaultsApplyFactory } from './route-tree-to-defaults-apply.factory';
import { Route } from './types';

export const itemRouteTreeGetFactory = <T extends Route = Route>(
  id: string,
  name: string,
  routeProcess: (i: Route) => void,
  queryParams?: any
) => {
  return routeTreeToDefaultsApplyFactory<T>(
    () => ({ name, params: { id }, query: queryParams }),
    i => {
      const params = (i.to.params ??= {});
      params.scope = i.id;
      routeProcess(i as Route);
    }
  );
};
